import { isNative } from 'src/utils/platform';
import { User } from 'src/types/user.types';
import { reportError } from 'src/modules/logs/Sentry';
import {
  initIntercomSupport,
  initUserToIntercomSupport,
  openIntercomMessenger,
} from 'src/modules/support/Intercom';
import { logAnalyticsEvent } from 'src/modules/analytics/analytics';
import type { SupportSource } from 'src/modules/support/support.types';

export const initSupport = async () => {
  if (!isNative()) {
    return;
  }

  try {
    await Promise.all([initIntercomSupport()]);
  } catch (error) {
    reportError('Error while initializing support', error);
  }
};

export const openSupportMessenger = async (source: SupportSource) => {
  logAnalyticsEvent('support_opened', { source });

  // Intercom is native-only: every plugin method throws "Not implemented on web", so on the web
  // build we skip it entirely rather than firing three guaranteed rejections (two tags + the
  // messenger) into Sentry for a messenger that can't open anyway.
  if (!isNative()) {
    return;
  }

  try {
    await openIntercomMessenger(source);
  } catch (error) {
    reportError('Error while opening support', error);
  }
};

export const initUserToSupport = async (user?: User) => {
  if (!isNative()) {
    return;
  }

  try {
    await Promise.all([initUserToIntercomSupport(user)]);
  } catch (error) {
    reportError('Error while init user to support', error);
  }
};
